import { Box, Typography } from "@mui/material";
import { RTL } from "../cache/CacheRtl";
import { v2 } from "../componenets/nutrition/v2/ui/v2Tokens";
import SavedMealsLibrary from "../componenets/nutrition/v2/SavedMealsLibrary";

/**
 * The company's saved meals, on their own page.
 *
 * A meal saved here is created from inside a menu and reused across trainees — company-owned, like
 * the food catalog and the supplement catalog beside it in the nav, and unlike anything on a single
 * client's page.
 *
 * Company foods are NOT here. They belong to the food catalog (מאגר מזון) — they are catalog rows
 * with a company_id, found by the same search as the shared ones — so a second place to browse them
 * would be a second answer to "what foods do we have". The catalog's "רק מזונות החברה" filter is
 * the one answer.
 */
const SavedMealsPage = () => (
  <RTL>
    <Box sx={{ display: "flex", flexDirection: "column", gap: "18px" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, flexWrap: "wrap" }}>
        <Typography
          sx={{
            fontSize: { xs: "22px", md: "26px" },
            fontWeight: 800,
            color: v2.ink,
            lineHeight: 1.2,
            letterSpacing: "-0.3px",
          }}
        >
          ארוחות שמורות
        </Typography>
        <Box sx={{ fontSize: "12.5px", color: v2.ink3 }}>משותפות לכל המאמנים בחברה</Box>
      </Box>

      <SavedMealsLibrary />
    </Box>
  </RTL>
);

export default SavedMealsPage;
